module.exports = __webpack_public_path__ + "static/other/space_pets.7ac0b80e.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/space_pets.json
// module id = 2505
// module chunks = 0